import viperLogo from "@/images/viper.png";
import { IImage } from "@/interfaces";
import { useGetProjectImagesQuery } from "@/services";
import { Image } from "antd";
import { useEffect, useState } from "react";
import { ImageWrapper } from "../styled";

interface IProps {
  projectId: string | undefined;
  projectName: string;
}

export const ProjectImage = ({ projectId, projectName }: IProps) => {
  const { data: projectImages } = useGetProjectImagesQuery({ projectId });

  const [image, setImage] = useState<IImage | null>(null);

  useEffect(() => {
    setImage(projectImages?.find((image: IImage) => image.isDefaultImage));
  }, [projectImages]);

  return (
    <ImageWrapper>
      <Image
        height={90}
        width={90}
        src={image?.url || viperLogo}
        alt={projectName}
      />
    </ImageWrapper>
  );
};
